import React from 'react'
import { Scrollchor } from 'react-scrollchor'

const LOCALES = {
  title: {
    de: 'So hat Ihre Gemeinde abgestimmt',
    fr: 'Voici ce que votre commune a voté'
  },
  lead: {
    de: (
      <>
        Erfahren Sie, wie man in Ihrer Gemeinde entschieden hat – auf
        nationaler, kantonaler und kommunaler Ebene.
      </>
    ),
    fr: (
      <>
        Découvrez comment votre commune a voté au niveau fédéral, cantonal et
        communal.
      </>
    )
  },
  urlSlug: {
    de: 'so-hat-ihre-gemeinde-abgestimmt',
    fr: 'voici-ce-que-votre-commune-a-vote'
  },
  votationDateTitle: {
    de: 'Abstimmungen vom',
    fr: 'Votations du'
  },
  noNationalVoteTitle: {
    de: 'Nur kantonale und kommunale Abstimmungen',
    fr: 'Votations cantonales et communales uniquement'
  },
  year: {
    de: 'Jahr',
    fr: 'Année'
  },
  municipaliyUrl: {
    de: 'gemeinde',
    fr: 'commune'
  },
  dateUrl: {
    de: 'datum',
    fr: 'date'
  },
  shareUrlTitle: {
    de: 'Teilen Sie diesen Abstimmungsbericht',
    fr: 'Partager ce contenu'
  },
  shareUrlText: {
    de: 'Teilen Sie diesen Direktlink mit Ihren Freunden und Bekannten!',
    fr: 'Partagez ce lien direct avec vos amis et vos connaissances!'
  },
  pastVotesTitle: {
    de: 'Vorherige Abstimmungen',
    fr: 'Votations précédentes'
  },
  findMunicipality: {
    de: 'Gemeinde auswählen',
    fr: 'Choisir une commune'
  },
  searchLabel: {
    de: 'Suchen Sie nach einer anderen Postleitzahl oder Gemeindenamen',
    fr: 'Cherchez par code postal ou par localité'
  },
  showMore: {
    de: 'Älterer Inhalt',
    fr: 'Votations plus anciennes'
  },
  allResults: {
    de: 'Alle Resultate',
    fr: 'Tous les résultats'
  },
  backToMain: {
    de: 'Zurück zur Startseite',
    fr: "Retour à la page d'accueil"
  },
  boxTitle: {
    de: 'Für Sie generierten wir folgenden Artikel',
    fr: 'Nous avons généré cet article pour vous'
  },
  learnMoreAboutVotes: {
    de: (
      <>
        Mehr zu den letzten{' '}
        <Scrollchor to='#latestVotesList'>Volksabstimmungen</Scrollchor>
      </>
    ),
    fr: (
      <>
        En savoir plus sur les dernières{' '}
        <Scrollchor to='#latestVotesList'>votations</Scrollchor>
      </>
    )
  },
  blockTitleFederal: {
    de: 'Eidgenössische Abstimmungen',
    fr: 'Votations fédérales'
  },
  blockTitleCantonal: {
    de: 'Kantonale Abstimmungen',
    fr: 'Votations cantonales'
  },
  blockTitleLocal: {
    de: 'Kommunale Abstimmungen und Wahlen',
    fr: 'Votations et élections communales'
  },
  signature: {
    de: 'Edgar Schuler und Patrice Siegrist, mit Textroboter Tobi',
    fr: 'Mathieu Signorell avec l’aide du robot Tobi'
  },
  municipalitySearchBoxTitle: {
    de: 'Eine andere Gemeinde anzeigen',
    fr: 'Cherchez une autre commune'
  },
  dashboardPrefix: { de: 'abstimmungen', fr: 'votations' },
  dashboardButton: {
    de: 'Zur Abstimmungsübersicht',
    fr: "Vers l'aperçu des votes"
  },
  votationLink: {
    de: 'Die Resultate in Karten',
    fr: 'Tous les résultats et toutes les cartes en détail'
  },
  votationLinkSup: {
    de: 'So stimmte die Schweiz',
    fr: 'Votations d’aujourd’hui'
  },
  gotoCanton: {
    de: 'Kantonale Abstimmungen',
    fr: 'Résultats cantonaux'
  },
  communalVotesTitle: {
    de: 'Kommunale Abstimmungen',
    fr: 'Résultats communaux'
  },
  gotoFederal: {
    de: 'Zu den eidgenössischen Ergebnissen',
    fr: 'Voir les résultats fédérales'
  },
  feedbackTitle: {
    de: 'Wie wars?',
    fr: 'Comment jugez-vous ce contenu?'
  },
  feedbackQuestions: {
    de: [
      'Funktionierte die technische Umsetzung?',
      'Wie beurteilen Sie die Textqualität?',
      'Wie beurteilen Sie den Nutzen dieses Textes?'
    ],
    fr: [
      'La mise en oeuvre technique a-t-elle fonctionné?',
      'Comment évaluez-vous la qualité du texte?',
      'Comment évaluez-vous l’utilité du texte?'
    ]
  },
  methodologyTitle: {
    de: <>Wie dieser Text geschrieben wurde</>,
    fr: <>Comment ce texte est-il écrit?</>
  },
  methodologyText: {
    de: (
      <>
        <p>
          Die Redaktion Tamedia hat einen regelbasierten Algorithmus entworfen,
          der die rund 4200 deutschen und französischen Abstimmmungstexte für
          über 2100 Gemeinden automatisch generiert. Die dafür benötigten Daten
          werden vom{' '}
          <a href='https://opendata.swiss/de/dataset/echtzeitdaten-am-abstimmungstag-zu-eidgenoessischen-abstimmungsvorlagen'>
            Bundesamt für Statistik
          </a>{' '}
          bezogen. Die Texte für kommunale Abstimmungen, falls vorhanden, werden
          von den Redaktionen selbst verfasst. Im Kanton Zürich werden diese
          Texte automatisch mit Daten des{' '}
          <a href='https://app.statistik.zh.ch/wahlen_abstimmungen/prod/#/Actual'>
            kantonalen statistischen Amts
          </a>{' '}
          generiert.
        </p>
        <p>
          Die Stimmbeteiligung zeigt die <i>durchschnittliche</i> Beteiligung
          bei den eidgenössischen Vorlagen für die jeweilige Gemeinde, den
          dazugehörigen Kanton und für die Gesamtschweiz.
        </p>
      </>
    ),
    fr: (
      <>
        <p>
          La rédaction de Tamedia a développé un algorithme permettant de
          générer ce texte. Les parties concernant les votes communaux font
          exception et sont rédigés par la rédaction. Les quelque 4200 textes et
          tableaux en français et en allemand disponibles ici sont basés sur les
          résultats des votes des plus de 2100 communes de Suisse. Les données
          sont fournies par{' '}
          <a href='https://opendata.swiss/fr/dataset/echtzeitdaten-am-abstimmungstag-zu-eidgenoessischen-abstimmungsvorlagen'>
            l’Office fédéral de la statistique
          </a>
          .
        </p>
        <p>
          Le taux de participation indique la participation <i>moyenne</i> de la
          population aux scrutins fédéraux, cantonaux et communaux.
        </p>
      </>
    )
  },
  credits: {
    de: [
      [
        'Programmierung',
        'Mathieu Rudaz (Frontend) und Timo Grossenbacher (Backend)'
      ],
      [
        'Datenaufbereitung',
        'Mathias Born, basierend auf Daten des Bundesamts für Statistik'
      ],
      [
        'Texte',
        "Timo Grossenbacher, Fanny Giroud und Paul Ronga (<a href='https://interactif.24heures.ch/voici-ce-que-votre-commune-a-vote/'>Französisch</a>) und die Tamedia-Redaktionen (kommunale Texte)"
      ],
      ['Bild', 'Viviane Futterknecht'],
      ['Projektleitung', 'Timo Grossenbacher']
    ],
    fr: [
      [
        'Programmation',
        'Mathieu Rudaz (Frontend) et Timo Grossenbacher (Backend)'
      ],
      [
        'Préparation des données',
        'Mathias Born, sur la base des données de l’Office fédéral de la statistique'
      ],
      [
        'Textes',
        "Fanny Giroud et Paul Ronga (briques de texte en français), Timo Grossenbacher (<a href='https://interaktiv.tagesanzeiger.ch/so-hat-ihre-gemeinde-abgestimmt/'>allemand</a>) et les rédactions de Tamedia (textes sur les objets communaux)"
      ],
      ['Illustration', 'Viviane Futterknecht'],
      ['Gestion du projet', 'Timo Grossenbacher']
    ]
  }
}

export default LOCALES
